import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import i18n from 'cityads-v3/i18n';
import moment from 'moment';
import { slugify } from 'transliteration';

import CircularProgress from '@mui/material/CircularProgress'
import TruncateWords from 'cityads-v3/components/Truncate/TruncateWords';
import Typography from '@mui/material/Typography';

import {
  ICONS_BY_NEWS_TYPE_NAME,
} from './icons';

import classes from './NewsList.scss';

@withRouter
@withTranslation(['News', 'main'], { i18n, wait: false })
export default class NewsList extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    emptyMessage: PropTypes.string,
    items: PropTypes.array,
    isLoading: PropTypes.bool,
    typesById: PropTypes.object,
    isLoadingTypes: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    typesById: {},
  }

  render() {
    const { t, location, className, title, emptyMessage, items, isLoading, typesById } = this.props;
    const baseRoute = location.pathname.replace(/\/news\/[^/]+$/, '');

    return (
      <div className={className}>
        {title ? (
          <div className={classes.title}>{title}</div>
        ) : false}

        {isLoading ?
          (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (items.filter(item => item).length ?
            items.map((newsItem, key) => {
              if (!newsItem) {
                return <div key={key}></div>
              }

              const itemCategory = typesById[newsItem.type_id] ? t(`types.${typesById[newsItem.type_id].name}`) : null;
              const Icon = ICONS_BY_NEWS_TYPE_NAME[typesById[newsItem.type_id]?.name] || null;

              return (
                <div key={key} className={classes.item}>
                  <Link
                    to = {{
                      ...location,
                      pathname: `${baseRoute}/news/${newsItem.id}-${slugify(itemCategory)}`,
                    }}
                    className = {classes.item__link}
                    data-news-id = {newsItem.id}
                  >
                    <div className={classes.item__head}>
                      {Icon ?
                        (
                          <Icon className={classes.item__img} titleAccess={itemCategory} />
                        ) :
                        null
                      }

                      <div>
                        <Typography component="div" className={classes.item__date}>{moment(newsItem.date_publish).format('L')}</Typography>
                        <Typography component="div" className={classes.item__category}>{itemCategory}</Typography>
                      </div>
                    </div>

                    <Typography component="div" className={classes.item__title}>
                      <TruncateWords lines={3} ellipsis={<span className={classes.item__more}>&nbsp;{t('main:more_info')}</span>}>
                        <div dangerouslySetInnerHTML={{ __html: newsItem.body }}></div>
                      </TruncateWords>
                    </Typography>
                  </Link>
                </div>
              )
            }) :
            (
              <Typography className={classes.empty} color="textSecondary">
                {emptyMessage}
              </Typography>
            )
          )
        }

      </div>
    );
  }

}


